<template>
  <div class="loading-wrapper">
    <div class="loading" :class="loading ? 'active' : ''">
      <i class="fa fa-spinner fa-spin" style="font-size: 48px; opacity: 0.75;"></i>
    </div>
    <slot />
  </div>
</template>

<style lang="scss">
  .loading-wrapper {
    position: relative;

    .loading {
      text-align: center;
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: -1000;

      &.active {
        padding-top: 150px;
        z-index: 1000;

        > * {
          position: fixed;
        }
      }
    }
  }
</style>
<script>

export default {
  props: ['loading'],
  name: 'pno-loading',
}
</script>
